
export default {
  name: 'IceHockeyIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
